




















import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
  }
})

export default class ConfirmOverrideModal extends Vue {
    isVisible = false;
    title = "削除しますか？";
    message1 = "";
    message2 = "上書きしますか？";

    onSelected : ((result : boolean) => void) | null = null;

    public open(filename : string, onSelected : (result : boolean) => void)
    {
        this.message1 = filename + " はすでに存在します。";
        this.isVisible = true;
        this.onSelected = onSelected;
    }

    onCancelButton()
    {
        this.isVisible = false;
        if(this.onSelected != null) this.onSelected(false);
    }

    onOkButton()
    {
        this.isVisible = false;
        if(this.onSelected != null) this.onSelected(true);
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigBackgroundColor(){
        var style = {
            background: this.userConfigColor
        };
        return style;
    }
}
